import { Stack, Typography } from '@mui/material';

import type { ForecastItem } from '@/types/Forecast';

interface ForecastBarsProps {
  items: ForecastItem[];
}

export function ForecastBars({ items }: ForecastBarsProps) {
  if (!items.length) return null;

  const getOccupancyColor = (percentage: number): string => {
    if (percentage >= 90) return '#e65638';
    if (percentage >= 75) return '#f3881c';
    if (percentage >= 50) return '#dcc400';

    return '#9bc22a';
  };

  return (
    <Stack ml={1.5} width={140}>
      <Typography>Auslastungsprognose</Typography>

      <Stack direction="row" justifyContent="space-between" mt={1}>
        {items.map((item) => {
          const percentage = Math.max(0, Math.min(100, item.value));
          const hoursAhead = item.horizon / 3600;

          return (
            <Stack key={item.horizon} textAlign="center">
              <Stack bgcolor="#f0f0f0" borderRadius={1} height={40} mb={0.5} position="relative" width={20}>
                <Stack
                  bgcolor={getOccupancyColor(percentage)}
                  borderRadius={1}
                  bottom={0}
                  height={`${percentage}%`}
                  position="absolute"
                  title={`${percentage.toFixed(0)}% Auslastung in +${hoursAhead}h`}
                  width="100%"
                />
              </Stack>
              <Typography variant="caption">+{hoursAhead}h</Typography>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
}
